<template>
  <v-app class="nx-primary--lighten-5">
    <v-layout align-center justify-center bgcolor="secondary">
      <div class="text-xs-center">
        <img :src="imageSvg" alt="Site mismatch" width="377" height="377"/>
        <br/>
        <h2>¡Ups!</h2>
        <p v-text="message"></p>
        <v-btn
          color="secondary" :href="fixedUrl" :target="target">
          {{ buttonText }}
        </v-btn>
      </div>
    </v-layout>
  </v-app>
</template>

<script>
import BasePage from '@/pages/BasePage';
import ImageSvg from '@/assets/status/site-mismatch.svg';

export default {
  name: 'nx-site-mismatch-error',
  extends: BasePage,
  props: {
    cmsSite: String,
    cmsSiteAlias: String,
    requestedSite: String,
    requestedSiteAlias: String,
    path: String,
    target: { type: String, default: '_self' },
  },
  computed: {
    message() {
      if (this.cmsSite && this.requestedSite) {
        return this.$t('message.error.siteMismatch', {
          cmsSite: this.cmsSite,
          requestedSite: this.requestedSite,
        });
      }
      return this.$t('message.error.siteMismatchSimple');
    },
    fixedUrl() {
      if (this.path
        && this.cmsSiteAlias
        && this.requestedSiteAlias
      ) {
        return this.path.replace(this.cmsSiteAlias, this.requestedSiteAlias);
      }
      return '/';
    },
    buttonText() {
      if (this.fixedUrl === '/') {
        return this.$t('message.common.goHome');
      }
      return this.$t('message.common.openInRequestedSite', {
        requestedSite: this.requestedSite,
      });
    },
  },
  data() {
    return {
      imageSvg: ImageSvg,
    };
  },
  mounted() {
    this.finishLoading();
  },
};
</script>
